import classNames from 'classnames';
import React from 'react';
import styles from './table-cell-wrapper.module.scss';

type Props = {
  className?: string;
  children: React.ReactNode;
  mobileLabel?: React.ReactNode;
  isMobileHeader?: boolean;
  colIndex: number;
};

export const TableCellWrapper: React.FC<Props> = ({ className, children, mobileLabel, isMobileHeader, colIndex }) => {
  const isString = typeof children === 'string';

  return (
    <div
      aria-colindex={colIndex}
      role="cell"
      className={classNames(styles.root, className, {
        [styles.isMobileHeader]: isMobileHeader,
      })}
    >
      {!isMobileHeader ? <div className={styles.mobileLabel}>{mobileLabel}</div> : null}
      <span
        className={classNames(styles.childrenContainer, {
          [styles.isString]: isString,
          [styles.isMobileHeader]: isMobileHeader,
        })}
      >
        {children}
      </span>
    </div>
  );
};
